import { RegisterRequestedFieldType } from "../requested-field-types"
import { RequestedFieldInput, RequestedFieldValue } from "../share-link-fields-slot-definitions"
import { DateFieldInput } from "../date-field-input"
import { DateFieldValue } from "../date-field-value"

/**
 * Self-registering plugin for the "date" requested-field type. Registers the type's metadata and plugs
 * its recipient input + read-only value renderers.
 */
RegisterRequestedFieldType.handleOnce(({ types }) => types.push({ value: "date", label: "Date", priority: 50 }))

RequestedFieldInput("date").plug(<DateFieldInput />)
RequestedFieldValue("date").plug(<DateFieldValue />)
